// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getValidDomainUrl } from "../../../actions/AuthActions/authMethods";

// Components Import
import TitleBar from "../../TitleBar";

// Declarations
const NAV_OPTIONS = [
  {
    alias: "organization",
    label: "My Templates",
    link: "/templates",
    icon: "files-medical",
  },
  {
    alias: "global",
    label: "Templates Library",
    url: `${getValidDomainUrl()}/templates`,
    icon: "globe",
  },
];

export default function TemplateLeftSection(props) {
  return (
    <div className="templateleftsection-wrapper">
      {/** TITLE SECTION */}
      <section className="templatesection-title-weapper">
        <TitleBar
          iconName="files-medical"
          title="Templates"
          subTitle="All your templates"
        />
      </section>
      <section className="templateleftsection-nav-options">
        {NAV_OPTIONS.map(option => (
          <div
            key={option.alias}
            className={`templateleftsection-title ${
              props.currentView === option.alias ? "is-active" : ""
            }`}>
            <span>
              <FontAwesomeIcon
                className="templateleftsection-title-icon show-hover"
                icon={["far", `${option.icon}`]}
              />
              <FontAwesomeIcon
                className="templateleftsection-title-icon hide-hover"
                icon={["fas", `${option.icon}`]}
              />
            </span>
            <span>
              {option.link && <Link to={option.link}>{option.label}</Link>}
              {option.url && (
                <a
                  href={option.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-test="templateleftsection-link">
                  {option.label}
                  <FontAwesomeIcon icon={["far", "external-link-alt"]} />
                </a>
              )}
            </span>
          </div>
        ))}
      </section>
    </div>
  );
}

TemplateLeftSection.propTypes = {
  currentView: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/TemplateV2/TemplateLeftSection/index.js